import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

const CursorFollower = () => {
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 500, damping: 40 });
  const sy = useSpring(y, { stiffness: 500, damping: 40 });
  const [hovering, setHovering] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const isTouch = window.matchMedia("(hover: none)").matches;
    if (isTouch) return;

    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      setVisible(true);
    };
    const checkHover = (e) => {
      const el = e.target;
      if (!el || !el.closest) return;
      setHovering(!!el.closest("a, button, [data-cursor-hover]"));
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", checkHover);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", checkHover);
    };
  }, [x, y]);

  if (!visible) return null;

  return (
    <>
      <motion.div
        className="fixed top-0 left-0 z-[100] pointer-events-none rounded-full"
        style={{
          x: sx,
          y: sy,
          translateX: "-50%",
          translateY: "-50%",
          width: hovering ? 44 : 12,
          height: hovering ? 44 : 12,
          background: hovering ? "rgba(0,122,255,0.18)" : "#007AFF",
          border: hovering ? "1px solid #007AFF" : "none",
          boxShadow: "0 0 24px rgba(0,122,255,0.55)",
          mixBlendMode: hovering ? "normal" : "screen",
          transition: "width 0.18s ease, height 0.18s ease, background 0.18s ease",
        }}
      />
    </>
  );
};

export default CursorFollower;
